module.exports = __webpack_public_path__ + "static/media/bluesky_grey.acbaa4fc.svg";